import { Controller } from "@hotwired/stimulus"

// An imported Shopware issue is a whole email, shown in a sandboxed frame as legacy's archive did. The frame grows to
// the mail's height so the page scrolls, not the frame.
export default class extends Controller {
  connect() {
    this.resize = this.resize.bind(this)
    this.element.addEventListener("load", this.resize)
    window.addEventListener("resize", this.resize)
    if (this.element.contentDocument?.readyState === "complete") this.resize()
  }

  disconnect() {
    this.element.removeEventListener("load", this.resize)
    window.removeEventListener("resize", this.resize)
  }

  resize() {
    const doc = this.element.contentDocument
    if (!doc?.body) return

    doc.querySelectorAll("img").forEach((img) => {
      if (!img.complete) img.addEventListener("load", this.resize, { once: true })
    })
    this.element.style.height = `${doc.documentElement.scrollHeight}px`
  }
}
